<template>
  <div id="top" class="out">
    <div class="title clear">
      <div class="apt">Apt #</div>
      <div class="status">Status</div>
      <div class="pri">Price</div>
      <div class="total">Total ㎡</div>
    </div>
    <div v-if="!loading" class="lst">
      <div v-if="list.length > 0">
        <div
          v-for="(item, index) in list"
          :key="item.a"
          :class="item.class"
          class="box"
          @click="toReserve"
        >
          <div
            :class="{ border: index == list.length - 1 || item.unfold }"
            class="line"
          >
            <div class="inn apt">{{ item.apt }}</div>
            <div class="inn status">{{ item.status }}</div>
            <div class="inn pri">
              ${{ item.revisedPrice }}
              {{
                item.revisedPriceMax == null || item.revisedPriceMax == 0
                  ? ""
                  : " - $" + item.revisedPriceMax
              }}
            </div>
            <div class="inn total">{{ item.total }}</div>
            <div
              :class="{ unfold: item.unfold }"
              class="inn arw"
              @click.stop="unfold(index)"
            ></div>
          </div>
          <div
            :class="{ hid: !item.unfold }"
            :style="{ marginBottom: item.unfold ? '.34rem' : '0' }"
            class="more"
          >
            <div class="top">
              <div class="tit clear">
                <div class="ouk">Outlook</div>
                <div class="bed">Beds</div>
                <div class="bat">Baths</div>
                <div class="car">Cars</div>
                <div class="int">Internal ㎡</div>
              </div>
              <div class="cons">
                <div class="ouk">{{ item.outlook }}</div>
                <div class="bed">{{ item.beds }}</div>
                <div class="bat">{{ item.baths }}</div>
                <div class="car">{{ item.cars }}</div>
                <div class="int">{{ item.internal }}</div>
              </div>
            </div>
            <div v-if="item.proertyType == 'House & Land'" class="mid">
              <div class="tit clear">
                <div class="est">Land Price</div>
                <div class="est">Build Price</div>
              </div>
              <div class="cons">
                <div class="land">${{ item.landPrice }}</div>
                <div class="land">${{ item.buildingPrice }}</div>
              </div>
            </div>
            <div class="bot">
              <div class="tit clear">
                <div class="bal">Balcony ㎡</div>
                <div class="land">Land ㎡</div>
                <div class="est">Est. rental (pw)</div>
              </div>
              <div class="cons">
                <div class="bal">{{ item.balcony }}</div>
                <div class="land">{{ item.storage }}</div>
                <div class="est">
                  ${{ item.anticipatedRent
                  }}<span v-if="item.anticipatedRentMax">
                    - ${{ item.anticipatedRentMax }}</span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        v-else
        style="text-align:center;padding:1rem 0;font-size:.3rem;color:#3F3F46"
      >
        No data
      </div>
    </div>
    <div v-if="loading" style="text-align:center;padding:1rem 0">
      <van-loading type="spinner" />
    </div>
    <!-- 当且仅当从首页/收藏进入，才可出现预定 -->
    <reverse
      :showReserve="showReserve && $route.params.operate == 0"
      @accept="reserve"
    ></reverse>
  </div>
</template>

<script>
import reverse from "@/components/package/reserve";
import { mapActions, mapMutations } from "vuex";

export default {
  data() {
    return {
      list: [],
      showReserve: true,
      pm: {},
      loading: true
    };
  },
  created() {
    var that = this;
    if (!that.$route.params.id) {
      that.$router.push("/");
      return;
    }
    that.pm = that.$route.params;
    that.getLst({
      params: {
        propertyId: that.pm.id,
        orderByKeyword: "apt",
        ascOrdesc: "asc"
      },
      callback: that.callback
    });
  },
  methods: {
    // 直接去预定页面
    toReserve() {
      this.$router.push({ path: `/property/selection/${this.pm.id}` });
    },
    unfold(i) {
      var that = this;
      that.list[i].unfold = !that.list[i].unfold;
    },
    reserve() {
      var that = this;
      that.$router.push({
        path: `/property/selection/${that.$route.params.id}`
      });
    },
    ...mapActions("price", ["getLst"]),
    ...mapMutations("login", ["cleartime"]),
    callback(res) {
      var that = this;
      that.loading = false;
      if (res.data.code == 0) {
        res.data.data.forEach(v => {
          v.unfold = false;
          if (JSON.stringify(v.revisedPrice).indexOf(".") !== -1) {
            v.revisedPrice = that.$box.formatSplit(v.revisedPrice, true);
          } else {
            v.revisedPrice = that.$box.formatSplit(v.revisedPrice, true);
          }
          if (JSON.stringify(v.landPrice).indexOf(".") !== -1) {
            v.landPrice = that.$box.formatSplit(v.landPrice, true);
          } else {
            v.landPrice = that.$box.formatSplit(v.landPrice, true);
          }
          if (JSON.stringify(v.buildingPrice).indexOf(".") !== -1) {
            v.buildingPrice = that.$box.formatSplit(v.buildingPrice, true);
          } else {
            v.buildingPrice = that.$box.formatSplit(v.buildingPrice, true);
          }
          if (JSON.stringify(v.revisedPriceMax).indexOf(".") !== -1) {
            v.revisedPriceMax = that.$box.formatSplit(v.revisedPriceMax, true);
          } else {
            v.revisedPriceMax = that.$box.formatSplit(v.revisedPriceMax, true);
          }
          if (JSON.stringify(v.anticipatedRent).indexOf(".") !== -1) {
            v.anticipatedRent = that.$box.formatSplit(v.anticipatedRent, true);
          } else {
            v.anticipatedRent = that.$box.formatSplit(v.anticipatedRent, true);
          }
          if (JSON.stringify(v.anticipatedRentMax).indexOf(".") !== -1) {
            v.anticipatedRentMax =
              v.anticipatedRentMax !== 0
                ? that.$box.formatSplit(v.anticipatedRentMax, true)
                : null;
          } else {
            v.anticipatedRentMax =
              v.anticipatedRentMax !== 0
                ? that.$box.formatSplit(v.anticipatedRentMax, true)
                : null;
          }

          if (v.status == "Reserved") {
            v.class = "grn";
          } else if (
            v.status == "Sold" ||
            v.status == "Unconditional" ||
            v.status == "Settled"
          ) {
            v.class = "prl";
            v.status = "Sold";
          }

          if (v.balcony === 0) {
            v.balcony = "N/A";
          }
          if (v.baths === 0) {
            v.baths = "Studio";
          }
          if (v.beds === 0) {
            v.beds = "N/A";
          }
          if (v.cars === 0) {
            v.cars = "N/A";
          }
          if (v.internal === 0) {
            v.internal = "N/A";
          }
          if (v.storage === "0" || v.storage === "" || v.storage === null) {
            v.storage = "N/A";
          }
          if (v.anticipatedRent === 0) {
            v.anticipatedRent = "N/A";
          }
          if (v.revisedPrice === 0) {
            v.revisedPrice = "N/A";
          }
          if (v.total === 0) {
            v.total = "N/A";
          }
        });
        that.list = res.data.data;
      } else if (
        res.data.code == 90000 ||
        res.data.code == 90002 ||
        res.data.code == 8902 ||
        res.data.code == 8901
      ) {
        that.$box.alert("", res.data.message, "error");
        localStorage.clear();
        that.$router.push("/login");
      }
    }
  },
  components: {
    reverse
  }
};
</script>

<style lang="scss" scoped>
.out {
  padding: 2.2rem 0.24rem 0.9rem 0.24rem;
  box-sizing: border-box;
  width: 100%;

  .title {
    width: 100%;
    margin-bottom: 0.24rem;
    font-size: 0.28rem;
    line-height: 0.34rem;
    color: #8c8c90;
    padding-top: 0.54rem;

    div {
      float: left;
      width: 13.58%;
      box-sizing: border-box;
      padding-left: 0.2rem;
    }

    .apt {
      width: 16.58%;
    }

    .status {
      width: 24.5%;
    }

    .pri {
      width: 27.77%;
    }

    .total {
      width: 26.05%;
    }
  }

  .lst {
    margin-bottom: 0.48rem;

    .box {
      width: 100%;
      border-right: 1px solid #dee3e0;
      cursor: pointer;

      .line {
        width: 100%;
        display: table;

        .inn {
          display: table-cell;
          line-height: 0.82rem;
          font-size: 0.28rem;
          color: #3f3f46;
          box-sizing: border-box;
          padding: 0 0.2rem;
          border-top: 1px solid #dee3e0;
          border-left: 1px solid #dee3e0;
          word-break: break-word;
        }

        .apt {
          width: 16.58%;
        }

        .status {
          width: 24.5%;
        }

        .pri {
          width: 27.77%;
        }

        .total {
          width: 26.05%;
        }

        .arw {
          width: 7.69%;
          cursor: pointer;
          position: relative;
        }

        .arw:after {
          content: "";
          display: block;
          width: 100%;
          height: 0.5rem;
          position: absolute;
          top: 0;
          left: 0;
          background-repeat: no-repeat;
          background-size: 0.26rem 0.14rem;
          background-position: center 0.3rem;
          background-image: url("../../../assets/arrw.png");
          transition: all 0.3s;
        }

        .unfold:after {
          transform: rotate(180deg);
          top: 0.16rem;
        }
      }

      .more {
        border: 1px solid #dee3e0;
        border-top: none;
        border-right: none;
        box-sizing: border-box;
        width: 100%;

        .top {
          width: 100%;
          box-sizing: border-box;
          padding: 0.4rem 0.2rem 0 0.4rem;
          margin-bottom: 0.18rem;

          .tit {
            width: 100%;
            font-size: 0.24rem;
            color: #8c8c90;
            line-height: 0.3rem;

            div {
              width: 20%;
              float: left;
            }

            div:nth-child(1) {
              width: 24%;
            }

            div:nth-child(2) {
              width: 18%;
            }

            div:nth-child(3) {
              width: 18%;
            }
          }

          .cons {
            width: 100%;
            font-size: 0.28rem;
            display: table;
            color: #3f3f46;

            div {
              width: 20%;
              display: table-cell;
              line-height: 0.82rem;
              box-sizing: border-box;
              padding-right: 0.1rem;
            }

            div:nth-child(1) {
              width: 24%;
            }

            div:nth-child(2) {
              width: 18%;
            }

            div:nth-child(3) {
              width: 18%;
            }
          }
        }

        .mid {
          width: 100%;
          box-sizing: border-box;
          padding: 0 0.2rem 0 0.4rem;
          margin-bottom: 0.18rem;

          .tit {
            width: 100%;
            font-size: 0.24rem;
            color: #8c8c90;
            line-height: 0.3rem;

            div {
              width: 42%;
              float: left;
            }

            div:nth-child(2) {
              width: 56%;
            }
          }

          .cons {
            width: 100%;
            font-size: 0.28rem;
            display: table;
            color: #3f3f46;
            line-height: 0.82rem;
            box-sizing: border-box;
            padding-right: 0.1rem;

            div {
              width: 42%;
              float: left;
            }

            div:nth-child(2) {
              width: 56%;
            }
          }
        }

        .bot {
          width: 100%;
          box-sizing: border-box;
          padding: 0 0.2rem 0 0.4rem;
          margin-bottom: 0.18rem;

          .tit {
            width: 100%;
            font-size: 0.24rem;
            color: #8c8c90;
            line-height: 0.3rem;

            div {
              width: 22%;
              float: left;
            }

            div:nth-child(3) {
              width: 56%;
            }
          }

          .cons {
            width: 100%;
            font-size: 0.28rem;
            display: table;
            color: #3f3f46;
            line-height: 0.82rem;
            box-sizing: border-box;
            padding-right: 0.1rem;

            div {
              width: 22%;
              float: left;
            }

            div:nth-child(3) {
              width: 56%;
            }
          }
        }
      }

      .hid {
        height: 0;
        overflow: hidden;
        border: none;
      }
    }

    .grn {
      background: #ecfaf2;
    }

    .prl {
      background: #f1f1f1;
    }

    .border {
      border-bottom: 1px solid #dee3e0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/details/price/price.vue